import React from 'react';
import { Wallet } from './Wallet';
import { motion } from 'framer-motion';

export const WalletsList = ({ wallets }) => {
  if (!wallets?.length) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-white/70 italic p-4 rounded-xl bg-white/10 backdrop-blur-md border border-white/10"
      >
        No vaults found for this user.
      </motion.div>
    );
  }

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            staggerChildren: 0.1,
          },
        },
      }}
      className=""
    >
      <div className="text-white/50 mx-4 text-xl font-semibold">Vaults</div>
      <div className="text-white/50 mb-4 mx-4 text-xs font-light">Displaying all current vaults for this user.</div>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {wallets.map((wallet) => (
          <motion.div
            key={wallet.id}
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            <Wallet wallet={wallet} />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};
